var _defs, _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgeProfile = function SvgAgeProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".age-profile_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 10.251,
    r: 2.25,
    className: "age-profile_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.5a3 3 0 0 0-3 3V19H19l.5 4.5h2L22 19h1.5v-2.5a3 3 0 0 0-3-3",
    className: "age-profile_svg__a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 10.251,
    r: 2.25,
    className: "age-profile_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.5a3 3 0 0 0-3 3V19H2l.5 4.5h2L5 19h1.5v-2.5a3 3 0 0 0-3-3",
    className: "age-profile_svg__a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.25,
    r: 2.75,
    className: "age-profile_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5a3.5 3.5 0 0 0-7 0v3h1.583l.417 5h3l.417-5H15.5ZM.5 6.5 11.537.613a1 1 0 0 1 .926 0L23.5 6.5",
    className: "age-profile_svg__a"
  })));
};
export default SvgAgeProfile;